import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ButtonRadiusEnum } from '../../../shared/components/button/types/button-radius.enum';
import { ButtonTypeEnum } from '../../../shared/components/button/types/button-type.enum';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { PasswordFeedbackComponent } from '../../../shared/components/password-feedback/password-feedback.component';
import { ToastService } from '../../../shared/components/toast/service/toast.service';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { getCrudErrors } from '../../../shared/utils/functions';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputTextModule } from 'primeng/inputtext';

interface PasswordForm {
  currentPassword: FormControl<string>;
  newPassword: FormControl<string>;
  confirmPassword: FormControl<string>;
}

@Component({
  selector: 'l-profile-password',
  standalone: true,
  imports: [ReactiveFormsModule, ButtonComponent, IconComponent, PasswordFeedbackComponent, FloatLabelModule, InputTextModule],
  templateUrl: './profile-password.component.html',
})
export class ProfilePasswordComponent {

  public isLoading = false;

  public hideCurrentPassword = true;

  public hideNewPassword = true;

  public hideConfirmPassword = true;

  public readonly buttonTypeEnum = ButtonTypeEnum;

  public readonly buttonRadiusEnum = ButtonRadiusEnum;

  public readonly form = new FormGroup<PasswordForm>({
    currentPassword: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
    newPassword: new FormControl('', { nonNullable: true, validators: [Validators.required, Validators.minLength(6)] }),
    confirmPassword: new FormControl('', { nonNullable: true, validators: [Validators.required] }),
  });

  private readonly authService = inject(AuthService);

  private readonly toastService = inject(ToastService);

  public async submit(): Promise<void> {
    const { currentPassword, newPassword, confirmPassword } = this.form.getRawValue();

    if (!currentPassword.trim() || !newPassword.trim() || !confirmPassword.trim()) {
      this.toastService.error('Preencha a senha atual, a nova senha e a confirmação.');
      return;
    }

    if (newPassword.length < 6) {
      this.toastService.error('É necessário enviar uma senha com 6 ou mais caracteres.');
      return;
    }

    if (newPassword !== confirmPassword) {
      this.toastService.error('As senhas não coincidem.');
      return;
    }

    this.isLoading = true;

    try {
      const message = await this.authService.changePassword(currentPassword, newPassword, confirmPassword);
      this.form.reset();
      this.toastService.success(message);
    } catch (error) {
      this.toastService.error(getCrudErrors(error)[0]);
    } finally {
      this.isLoading = false;
    }
  }

}
